import React, { useEffect, useState } from 'react'
import { userBridge, getUA, callNativeByParams } from '@penguin/utils'
import { STATS_MAP } from '@/utils'
import { getEncodeUserId, getSlotAd } from '@/api'
import { replaceUrlParam } from '@/utils'
import classnames from 'classnames'
import qs from 'query-string'
import { useTop } from '@/hooks'
import styles from './index.module.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
const ua = getUA()

const SLOT_KEYS = {
  right: 'marketing-h5-haoka-right-banner',
  left: 'marketing-h5-haoka-left-banner',
  top: 'marketing-h5-haoka-top-banner',
}

const CardAd = () => {
  const navInfo = callNativeByParams('getAppStateBarAndNavBarHeight') as {
    stateBarHeight: string
    navBarHeight: string
    webViewHeight: string
  }
  const { wrapRef, scrollNav } = useTop()
  const { channel = '', tab = 'left' } = qs.parse(location.search) as {
    channel: string
    tab: string
  }
  const [tabStatus, setTabStatus] = useState(tab)
  const [slotInfo, setSlotInfo] = useState({
    top: [],
    left: [],
    right: [],
  })

  const getSlot = async () => {
    const [top, left, right] = await Promise.all([
      getSlotAd({ slotKey: SLOT_KEYS.top }),
      getSlotAd({ slotKey: SLOT_KEYS.left }),
      getSlotAd({ slotKey: SLOT_KEYS.right }),
    ])
    setSlotInfo((pre) => ({
      ...pre,
      top: top?.images || [],
      left: left?.images || [],
      right: right?.images || [],
    }))
  }
  useEffect(() => {
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        STATS_MAP.cardAd.exposure,
        'CLK',
        {
          page: '新号卡页面',
          channel,
        },
      ],
    })
    getSlot()
    userBridge('showOrHiddenStateBar', {
      isHidden: 1,
    })
    return () => {
      userBridge('showOrHiddenStateBar', {
        isHidden: 0,
      })
    }
  }, [])

  const jumpUrl = (url: string) => {
    if (ua === 'app') {
      userBridge('pushWindow', {
        url,
        closeCurrentWindow: false,
        closeAllWindow: false,
      })
    } else {
      window.location.href = url
    }
  }

  const goPage = async (i: any, type?: string) => {
    let url = i.linkUrl
    if (type === 'jump') {
      jumpUrl(url)
      return
    }
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        STATS_MAP.cardAd.click,
        'CLK',
        {
          channel,
          page: '新号卡页面',
          naem: i.name,
        },
      ],
    })
    const res = await getEncodeUserId()
    url = replaceUrlParam(url, 'channelOrderId', encodeURIComponent(res || ''))
    jumpUrl(url)
    return
  }

  return (
    <div
      className={classnames(
        ' relative p-3 rem:pt-[44px] w-full pb-10',
        styles['card'],
        styles['card-vip'],
      )}
      ref={(ref) => {
        wrapRef.current = ref
      }}
    >
      {ua === 'app' && (
        <div
          className={classnames(
            'w-full fixed z-10 top-0 left-0',
            scrollNav ? styles['navstyl'] : styles['unnavstyl'],
          )}
          style={{ paddingTop: +navInfo.stateBarHeight || 44 }}
        >
          <div className=' rem:h-[44px] relative flex items-center justify-center'>
            <img
              className=' w-6 h-6 absolute left-1'
              src='//static.qiekj.com/static/web/image/icon-left_1686626401509.png'
              alt=''
              onClick={() => userBridge('popWindow')}
            />
            {scrollNav  && <span className='rem:text-[17px] text-default'>胖乖营业厅</span>}
          </div>
          {scrollNav && <div className="flex justify-around">
            <div onClick={() => setTabStatus('left')} className={classnames('flex-0 flex flex-col justify-center items-center', styles['top-tab-text'], tabStatus === 'left' && styles['top-tab-active'])}>
              <span>流量卡</span>
              <span className={classnames(tabStatus === 'left' ? styles['tab-line'] : styles['tab-line-no'])}></span>
            </div>
            <div onClick={() => setTabStatus('right')} className={classnames('flex-0 flex flex-col justify-center items-center', styles['top-tab-text'], tabStatus === 'right' && styles['top-tab-active'])}>
              <span>流量包</span>
              <span className={classnames(tabStatus === 'right' ? styles['tab-line'] : styles['tab-line-no'])}></span>
            </div>
          </div>}
        </div>
      )}
      <img
        className=' absolute top-0 left-0'
        src='//static.qiekj.com/static/web/image/bg_1715842597832.png'
        alt=''
      />
      <Swiper
        autoplay={{
          delay: 1000,
        }}
        loop
        modules={[Autoplay]}
        className={classnames(styles['swiper'], 'rem:mt-[126px]')}
        direction={'vertical'}
      >
        {slotInfo.top?.map((i: any) => (
          <SwiperSlide key={i.linkUrl} className={classnames(styles['swiper-slide'])}>
            <img
              onClick={() => goPage(i, 'jump')}
              className='!w-full !h-full'
              src={i.imageUrl}
              alt=''
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className=' mt-4'>
        <div
          className={classnames(
            styles['left-tab'],
            tabStatus === 'right' && styles['right-tab'],
            'rem:h-[89px]',
          )}
        >
          <div
            onClick={() => {
              setTabStatus('left')
            }}
            className={classnames(styles['left-tab-btn'])}
          ></div>
          <div
            onClick={() => {
              setTabStatus('right')
            }}
            className={classnames(styles['left-tab-btn'])}
          ></div>
        </div>
      </div>
      <div className='relative rem:mt-[76px]'>
        {tabStatus === 'left' ? (
          <>
            <img src='//static.qiekj.com/static/web/image/left-top_1715842597832.png' alt='' />
            {slotInfo.left?.map((i: any) => {
              return (
                <img
                  onClick={() => goPage(i)}
                  className='rem:mt-[10px]'
                  key={i.linkUrl}
                  src={i.imageUrl}
                />
              )
            })}
            <img
              className=' rem:mt-[10px]'
              src='//static.qiekj.com/static/web/image/card-progress_1715842597832.png'
              alt=''
            />
            <img
              className=' rem:mt-[10px]'
              src={'//static.qiekj.com/static/web/image/vip-rule-bg_1716283925684.png'}
              alt=''
            />
          </>
        ) : (
          <>
            <img src='//static.qiekj.com/static/web/image/right-top_1715842597832.png' alt='' />
            {slotInfo.right.length ? (
              slotInfo.right?.map((i: any) => {
                return (
                  <img
                    onClick={() => goPage(i)}
                    className='rem:mt-[10px]'
                    key={i.linkUrl}
                    src={i.imageUrl}
                  />
                )
              })
            ) : (
              <div
                className={classnames(
                  styles['no-card'],
                  'rem:p-[80px] rem:text-[12px] text-center',
                )}
              >
                暂无可领取的流量包
              </div>
            )}
            <img
              className=' rem:mt-[10px]'
              src='//static.qiekj.com/static/web/image/right-rule_1715842597832.png'
              alt=''
            />
          </>
        )}
      </div>
    </div>
  )
}

export default CardAd
